import { Component, OnInit } from '@angular/core';
import { FilteredListConfig, FilteredListItem, Badge } from '@appcatalyst/ng-cms-core-lib';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-cities',
  templateUrl: './cities.component.html',
  styleUrls: ['./cities.component.scss'],
  providers: [FilteredListConfig]
})
export class CitiesComponent implements OnInit {
  cities$: Observable<any>
  private cities: any[]
  params: any
  
  constructor(
    private config: FilteredListConfig,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.params = {...params}
    })
    this.route.data.subscribe((data: {cities: any}) => {
      this.cities$ = data.cities
      this.cities = data.cities
      this.config.listItems = this.cities.map(city => {
        return {
          _id: null,
          title: city,
        }
      });
      this.config.count = this.cities.length
      this.config.page = 1
      this.config.limit = this.cities.length
      this.config.emitChanges()
    })
    this.config.title = 'Cities'
  }
}
